export default __webpack_public_path__ + "static/media/user-avatar_dark.9532252d.svg";